import { ArrayInput, FormDataConsumer, SimpleFormIterator } from "react-admin";
import Inputs from "./Inputs";

export default function SaleOrderItemForm() {
  return (
    <ArrayInput
      source="sale_order_items"
      defaultValue={[
        {
          code: "",
          quantity: "",
          name: "", // disabled
          stock: "", // disabled
          pending: "", // disabled
          price: "",
          subtotal: "",
        },
      ]}
    >
      <SimpleFormIterator
        disableReordering
        getItemLabel={(index) => `#${index + 1}`}
        fullWidth={true}
        sx={{
          "& .RaSimpleFormIterator-line": {
            border: "none",
          },
        }}
      >
        <FormDataConsumer>{Inputs}</FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
}
